import { useEffect, useState } from 'react';
import { fetchPostsApi } from '../../../api/admin/post.api';

export const usePostManagementHook = ({
  pageNumber,
  isRefetch,
  status,
}: {
  pageNumber?: number;
  isRefetch?: boolean;
  status?: string;
}) => {
  const [posts, setPosts] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState<boolean>(false);
  useEffect(() => {
    getUsers(pageNumber);
  }, [pageNumber, isRefetch, status]);
  const getUsers = async (pageNumber) => {
    try {
      setLoading(true);
      const { data } = await fetchPostsApi(pageNumber, status);
      setPosts(data.data);
      setHasMore(!!data.hasMore);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };
  return {
    data: posts,
    loading,
    hasMore,
  };
};

export interface IPostModel {
  id: string;
  content: string;
  title: string;
  userId: string;
  postType: string;
  createdAt: string;
  detectedBannedWords?: string;
  // Other fields...
}
